@if ($facets | async; as data) {
  @if (data.length) {
    @if (isTabletAndDown$()) {
      <boels-vertical-aligner class="boels-product-filter mobile-view-only">
        <mat-accordion class="boels-product-filter mobile-view">
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <fa-icon
                  [icon]="faFilterIcon"
                  size="lg"
                  class="filter-icon"
                ></fa-icon>
                {{ 'productFilter.filter' | transloco }}
              </mat-panel-title>
              <fa-icon
                class="chevron-icon"
                [icon]="faChevronDown"
                size="xs"
              ></fa-icon>
            </mat-expansion-panel-header>
            @if (showClearFilters) {
              <div class="clear-filters-wrapper">
                <fa-icon
                  [icon]="faTimesIcon"
                  size="sm"
                  class="filter-icon"
                ></fa-icon>
                <a
                  class="filter-heading__clear-filters"
                  (click)="onClearFilters()"
                  >{{ 'productFilter.clearFilters' | transloco }}</a
                >
              </div>
            }
            @for (value of data; track value) {
              <div class="filters">
                <div class="filters__title">{{ value.name }}</div>
                @for (option of value.values | slice: 0 : 6; track option) {
                  <mat-checkbox
                    (click)="onFilterChange($event, option)"
                    [checked]="option.selected"
                  >
                    {{ option.name }} ({{ option.count }})
                  </mat-checkbox>
                }
                @if (value.isExpandable && !value.isExpanded) {
                  <a
                    class="btn-show-more"
                    (click)="value.isExpanded = !value.isExpanded"
                  >
                    {{ 'productFilter.showMore' | transloco }}...
                  </a>
                }
                @if (value.isExpanded) {
                  @for (
                    option of value.values | slice: 6 : value?.values?.length;
                    track option
                  ) {
                    <mat-checkbox
                      (click)="onFilterChange($event, option)"
                      [checked]="option.selected"
                    >
                      {{ option.name }} ({{ option.count }})
                    </mat-checkbox>
                  }
                  @if (value.isExpandable && value.isExpanded) {
                    <a
                      class="btn-show-less"
                      (click)="value.isExpanded = !value.isExpanded"
                    >
                      {{ 'productFilter.showLess' | transloco }}...
                    </a>
                  }
                }
              </div>
            }
          </mat-expansion-panel>
        </mat-accordion>
      </boels-vertical-aligner>
    } @else {
      <div class="boels-product-filter desktop-view-only">
        @if (data?.length) {
          <div class="filter-heading">
            <p class="filter-heading__filter">
              {{ 'productFilter.filter' | transloco }}
            </p>
            @if (showClearFilters) {
              <a
                class="filter-heading__clear-filters"
                (click)="onClearFilters()"
                >{{ 'productFilter.clearFilters' | transloco }}</a
              >
            }
          </div>
        }
        <mat-accordion [multi]="true">
          @for (value of data; track value; let i = $index) {
            <mat-expansion-panel
              hideToggle
              [expanded]="isExpansionPanelExpanded(value.name)"
            >
              <mat-expansion-panel-header
                (click)="
                  updateExpansionPanelData(
                    value.name,
                    !isExpansionPanelExpanded(value.name)
                  )
                "
              >
                <mat-panel-title>
                  {{ value.name }}
                </mat-panel-title>
                <fa-icon
                  class="chevron-icon"
                  [icon]="faChevronDown"
                  size="xs"
                ></fa-icon>
              </mat-expansion-panel-header>
              @for (option of value.values | slice: 0 : 6; track option) {
                <mat-checkbox
                  (click)="onFilterChange($event, option)"
                  [checked]="option.selected"
                >
                  {{ option.name }} ({{ option.count }})
                </mat-checkbox>
              }
              @if (value.isExpandable && !value.isExpanded) {
                <a
                  class="btn-show-more"
                  (click)="value.isExpanded = !value.isExpanded"
                >
                  {{ 'productFilter.showMore' | transloco }}...
                </a>
              }
              @if (value.isExpanded) {
                @for (
                  option of value.values | slice: 6 : value?.values?.length;
                  track option
                ) {
                  <mat-checkbox
                    (click)="onFilterChange($event, option)"
                    [checked]="option.selected"
                  >
                    {{ option.name }} ({{ option.count }})
                  </mat-checkbox>
                }
                @if (value.isExpandable && value.isExpanded) {
                  <a
                    class="btn-show-less"
                    (click)="value.isExpanded = !value.isExpanded"
                  >
                    {{ 'productFilter.showLess' | transloco }}...
                  </a>
                }
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }
  }
}
